const APPROVAL_LEVELS = {
  NONE: 'NONE',
  TIER3_APPROVAL: 'TIER3_APPROVAL',
  TIER2_APPROVAL: 'TIER2_APPROVAL',
  TIER1_APPROVAL: 'TIER1_APPROVAL'
};

const VALIDATION_LEVELS = {
  VALID: 'VALID',
  FORBIDDEN: 'FORBIDDEN',
  INVALID: 'INVALID',
  TIER3_APPROVAL: 'TIER3_APPROVAL',
  TIER2_APPROVAL: 'TIER2_APPROVAL',
  TIER1_APPROVAL: 'TIER1_APPROVAL',
  REASON_REQUIRED: 'REASON_REQUIRED'
};

const APPROVAL_LEVELS_MAPPING = {
  None: APPROVAL_LEVELS.NONE,
  Tier1: APPROVAL_LEVELS.TIER1_APPROVAL,
  Tier2: APPROVAL_LEVELS.TIER2_APPROVAL,
  Tier3: APPROVAL_LEVELS.TIER3_APPROVAL
};

const APPROVAL_LEVELS_ORDINAL = {
  NONE: 0,
  TIER3_APPROVAL: 3,
  TIER2_APPROVAL: 2,
  TIER1_APPROVAL: 1
};

const INVENTORY_MAINTENANCE_TYPES = {
  FIXED: 'FIXED',
  NO_SRC: 'NO SRC'
};

const MERCHANDISE_TYPES = {
  GARMENTS: 'GARMENTS'
};

export {
  APPROVAL_LEVELS,
  APPROVAL_LEVELS_MAPPING,
  APPROVAL_LEVELS_ORDINAL,
  INVENTORY_MAINTENANCE_TYPES,
  MERCHANDISE_TYPES,
  VALIDATION_LEVELS
};
